import React from 'react';
import { Page } from '@fiverr-private/perseus';
import GigPage from '../components/GigPage';

class GigPageClient extends Page {
    render() {
        return (
            <GigPage {...this.props}/>
        );
    }
}

export default GigPageClient;
